module.exports = __webpack_public_path__ + "img/mobile scanner stand04.e0811a9e.jpg";